<template>
  <v-container fluid class="creativeproject-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn @click="requestProject" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Request
              </v-btn>
              <v-btn color="success" class="button-shadow mr-3" @click="findCreativeProjectDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              loading-text="Loading... Please wait"
              class="creativeprojects-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="itemHeaders"
              :items="[
                ...ctvprojects.filter(project=>project.projectstatus!='Completed'),
                ...ctvprojects.filter(project=>project.projectstatus=='Completed'),
              ]"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteProject"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Creative Project?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_project.projectnum }} 
                      {{ delete_project.projectname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteProject = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteCreativeProject(delete_project)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>

              <template v-slot:item.reqid="{ item }">
                <div v-if="item.reqid!=null">
                  <p class="two-line" style="margin-left: 15px;">
                    <v-avatar v-if="item.reqid!=null && users.length>0" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.reqid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <p class="two-line"><span class="white--text headline">{{ item.reqid!=null && users.length>0 ? users.find(user=>user._id == item.reqid)['username'][0].toUpperCase() : '' }}</span></p>
                    </v-avatar>
                  </p>
                <p class="two-line"><span style="margin-left:15px; font-size: small;">{{ item.reqid!=null && users.length>0 ? users.find(user=>user._id == item.reqid)['username'] : '' }} </span></p>
                <p class="two-line"><span style="margin-left:15px">{{ item.reqid!=null && users.length>0 ? users.find(user=>user._id == item.reqid)['companycode'] : '' }} </span></p>
              </div>
              </template>
              <template v-slot:item.repid="{ item }">
                <div v-if="item.repid!=null">
                  <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.repid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.repid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.repid!=null && users.length>0 ? users.find(user=>user._id == item.repid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px; font-size: small;">{{ item.repid!=null && users.length>0 ? users.find(user=>user._id == item.repid)['username'] : '' }} </span></p>
                <p class="two-line"><span style="margin-left:15px">{{ item.repid!=null && users.length>0 ? users.find(user=>user._id == item.repid)['companycode'] : '' }} </span></p>
              </div>
              </template>
              <template v-slot:item.projectimage="{ item }">
                    <v-img
                    v-if="item.projectimage" 
                    v-bind:src="item.projectimage"
                    max-height="75"
                    max-width="75"
                  ></v-img>
              </template>
              <template v-slot:item.projectnum="{ item }">
                <p class="two-line" style="font-weight: 600;">Project #{{ item.projectnum  }}</p>
                <p class="two-line" style="font-weight: 600;">{{ item.mktprojectname }}</p>
                <p class="two-line">{{ item.projectchannel  }}: {{ item.projecttype  }}</p>
                <p class="two-line" style="font-size: 10pt;">{{ item.projectname }}</p>
                <p class="two-line">{{ new Date(item.projectdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                <p v-if="item.creativeprojectdate!=undefined" class="two-line">{{ new Date(item.creativeprojectdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.times="{ item }">
                {{ item.times.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.timehour),0).toFixed(2) }}
              </template>
              <template v-slot:item.medias="{ item }">
                <p class="two-line"><span style="font-size: x-small;">{{ getMediaStatus(item.medias) }}</span></p>
                <p class="two-line">{{ item.medias.length }}</p>
              </template>
              <template v-slot:item.messages="{ item }">
                {{ item.messages.length }}
              </template>
              <template v-slot:item.projectreqdate="{ item }">
                  <v-progress-linear
                  :key="item._id"
                  v-model="item.projectprogress"
                  :color="'primary'"
                ></v-progress-linear>
                <div v-if="item.projectstatus!=='Completed'">
                  <p v-if="item.projectreqdate!=null" class="two-line" style="margin-top: 10px; font-size: 9pt;"><b>Complete By:</b></p>
                  <p v-if="item.projectreqdate!=null" class="two-line" style="font-size:small;">{{ new Date(item.projectreqdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                </div>  
                <div v-if="item.projectstatus=='Completed'">
                  <p v-if="item.completedAt!=null" class="two-line" style="margin-top: 10px; font-size: 9pt;"><b>Completed On:</b></p>
                  <p v-if="item.completedAt!=null" class="two-line" style="font-size: small;">{{ new Date(item.completedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                </div>  
              </template>
              <template v-slot:item.projectstatus="{ item }">
                <v-chip
                  v-if="item.projectstatus!=undefined"
                  :color="getStatusColor(item.projectstatus)" small>
                  {{ item.projectstatus }}
                </v-chip>
                <p class="two-line" style="font-size: xx-small;">{{ item.projectnote }}</p>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn v-if="item.projectstatus=='Assigned' && item.repid==userid" icon color="primary" @click="responseProject(item)">
                  <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.projectstatus=='Accept' || item.projectstatus=='Working' || item.projectstatus=='Completed'" icon color="primary" @click="manageProject(item)">
                  <v-icon>mdi-folder-search-outline</v-icon>
                </v-btn>
                <!-- <v-btn v-if="item.projectstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn> -->
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="findCreativeProjectDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Creative Projects</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-select
                    :items="['Branding', 'Design', 'Writing']"
                    v-model="query.projectchannel"
                    label="Project Channel"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-select
                    :items="['New', 'Assigned', 'Accept', 'Working', 'Completed']"
                    v-model="query.projectstatus"
                    label="Project Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Project Num"
                    v-model="query.projectnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Project Num">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_project_startdate"
                    v-model="menu_project_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="query.project_startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="query.project_startdate"
                        label="Project Start Date"
                        v-bind="attrs"
                        v-bind:value="query.project_startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      ></v-text-field>
                    </template>
                      <v-date-picker
                        v-model="query.project_startdate"
                        no-title
                        scrollable
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_project_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_project_startdate.save(query.project_startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_project_enddate"
                    v-model="menu_project_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="query.project_enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="query.project_enddate"
                        label="Project End Date"
                        v-bind="attrs"
                        v-bind:value="query.project_enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      ></v-text-field>
                    </template>
                      <v-date-picker
                        v-model="query.project_enddate"
                        no-title
                        scrollable
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_project_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_project_enddate.save(query.project_enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_complete_startdate"
                    v-model="menu_complete_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="query.complete_startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="query.complete_startdate"
                        label="Completed Start Date"
                        v-bind="attrs"
                        v-bind:value="query.complete_startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      ></v-text-field>
                    </template>
                      <v-date-picker
                        v-model="query.complete_startdate"
                        no-title
                        scrollable
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_complete_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_complete_startdate.save(query.complete_startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_complete_enddate"
                    v-model="menu_complete_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="query.complete_enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="query.complete_enddate"
                        label="Completed End Date"
                        v-bind="attrs"
                        v-bind:value="query.complete_enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="query.complete_enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_complete_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_complete_enddate.save(query.complete_enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="findCreativeProjectDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetCreativeProjects"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findCreativeProjects"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'CreativeProjectList',
  data() {
    return {
      userid: null,
      isDeleteProject: false,
      findCreativeProjectDialog: false,
      menu_project_startdate: null,
      menu_project_enddate: null,
      menu_complete_startdate: null,
      menu_complete_enddate: null,
      itemPerPage: 500,
      delete_project: {},
      query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemHeaders: [
        { text: 'Image', value: 'projectimage', sortable: false, width: "5%" },
        { text: 'Project', value: 'projectnum', sortable: false },
        { text: 'Hrs', value: 'times', sortable: false , width: "4%"},
        { text: 'Mda', value: 'medias', sortable: false , width: "4%"},
        { text: 'Msg', value: 'messages', sortable: false , width: "4%"},
        { text: 'Progress', value: 'projectreqdate', sortable: false , width: "7%"},
        { text: 'Requestor', value: 'reqid', width: "10%"},
        { text: 'Creator', value: 'repid', width: "10%"},
        { text: 'Status', value: 'projectstatus', width: "8%"},
        { text: 'Actions', value: 'actions', sortable: false, width: "8%"},
      ],
      users: [],
      mktprojects: [],
      ctvprojects: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('CreativeProject', ['projects', 'isReceiving', 'isDeleting', 'idToDelete', 'creativeprojectsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('CreativeProject', ["getCreativeProjectsRequest", "findCreativeProjectsRequest", "deleteCreativeProjectRequest","updateCreativeProjectRequest","createCreativeProjectRequest"]),
    ...mapActions('User', ["getUsersAllRequest"]),
    getMediaStatus(medias){
      if(medias.find(media=>media.mediatype=='Final File')!=null) return 'Final';
      else if(medias.find(media=>media.mediatype=='Draft File')!=null) return 'Draft';
      return '';
    },
    responseProject(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'CreativeProjectResponse', params: item });
    },
    manageProject(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'CreativeProjectManage', params: item });
    },
    requestProject(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'CreativeProjectRequest', params: item });
    },
    async findCreativeProjects(){
      this.findCreativeProjectDialog = false;
      if(this.query=={}){
        await this.getCreativeProjectsRequest();
        this.ctvprojects = Object.assign([], this.projects);
      }
      else{
        let result = await this.findCreativeProjectsRequest(this.query);
        this.ctvprojects = Object.assign([], result);
      }
    },
    async resetCreativeProjects(){
      this.query = {};
    },
    async deleteCreativeProject(item) {
      await this.deleteCreativeProjectRequest(item);
      this.isDeleteProject = false;
    },
    deleteDialog(item) {
      this.isDeleteProject = true;
      this.delete_project = {_id: item._id, projectnum: item.projectnum, projectname: item.projectname};
    },
  },
  async created () {
    this.userid = localStorage.getItem('userid');
    await this.getCreativeProjectsRequest();
    this.ctvprojects = Object.assign([], this.projects);
    if(this.users.length==0) this.users = await this.getUsersAllRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
